import {Worksheet} from 'exceljs';
import {decorateCell, setCellValue} from 'src/modules/downloads/cells/cells';
import {DEFAULT_DATE_FORMAT, HorizontalAlignment} from 'src/modules/downloads/cells/styles';

import {formatDate} from '@pb/kit-formatters';

const CREATED_FOR_TITLE = 'Created for:';
const DOWNLOADED_ON_TITLE = 'Downloaded on:';
const COPYRIGHT = '© PitchBook Data, Inc.';

export const printMetadata = (worksheet: Worksheet, userName: string) => {
    decorateCell(worksheet.getCell('E3'), setCellValue(DOWNLOADED_ON_TITLE, HorizontalAlignment.RIGHT));
    decorateCell(worksheet.getCell('F3'), setCellValue(formatDate(new Date(), DEFAULT_DATE_FORMAT)));
    decorateCell(worksheet.getCell('E4'), setCellValue(CREATED_FOR_TITLE, HorizontalAlignment.RIGHT));
    decorateCell(worksheet.getCell('F4'), setCellValue(userName));
    decorateCell(worksheet.getCell('F5'), setCellValue(`${COPYRIGHT} ${new Date().getFullYear()}`));
};
